module.exports = __webpack_public_path__ + "img/ico_phmeter54-59.e70846ae.svg";